<div
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  cdkDragHandle
  style="position: relative; overflow: auto; height: 100%"
>
  <mat-horizontal-stepper
    [linear]="isLinear"
    #stepper="matHorizontalStepper"
    style="height: 100%; display: flex; flex-direction: column"
  >
    <mat-step [stepControl]="columnNamesGroup">
      <div class="container">
        <div class="row" style="margin-top: 2%; margin-bottom: 2%">
          <div
            class="col-lg-12 text-center"
            style="font-weight: bold; font-size: 18px"
          >
            Field Types
          </div>
        </div>
      </div>

      <!--Scrolling field types-->
      <div
        class="container"
        style="
          height: 61vh;
          overflow: scroll;
          display: flex !important;
          flex-direction: column;
        "
      >
        <div
          class="row topRowMargins"
          *ngFor="let fieldsMetaDataTemp of retrieveFieldsObjectArray"
        >
          <!--Changing background color of selected field-->
          <div
            class="col-lg-6"
            *ngFor="let fieldsMetaDataTemporary of fieldsMetaDataTemp"
          >
            <div
              style="
                padding-top: 3%;
                padding-bottom: 3%;
                border-style: solid;
                border-width: 1.5px;
              "
              (click)="selectFieldType(fieldsMetaDataTemporary.fieldType)"
              [style.backgroundColor]="
                fieldsMetaDataTemporary.backgroundColorChange
              "
              title="Click on the field type to enter field details."
            >
              <div class="text-center">
                {{ fieldsMetaDataTemporary.fieldType }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="row topRowmargins" style="margin-top: 2%">
          <div class="col-lg-12 text-center">
            <button
              type="button"
               class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
               [style.background-color]="backgroundColorButton"  
                style="
                font-size: 0.85rem;
                padding-left: 1.2rem;
                padding-right: 1.2rem;
                padding-top: 0.4rem;
                padding-bottom: 0.4rem;
              "
              (click)="close()"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </mat-step>

    <mat-step [stepControl]="fieldsGroup">
      <div *ngIf="showingFields">
        <div class="container">
          <div
            class="row topRowmargins"
            style="margin-top: 2%; margin-bottom: 2%; font-weight: bold"
          >
            <div class="col-lg"></div>

            <div class="col-lg text-center">
              {{ selectedFieldType }}
            </div>

            <div class="col-lg"></div>
          </div>

          <!--Scrolling form fields and number of forms-->
          <div
            style="
              height: 55vh;
              overflow: scroll;
              overflow-x: hidden;
              display: flex !important;
              flex-direction: column;
            "
          >
            <!--This is for entering number of forms-->
            <div
              class="row topRowmargins"
              style="margin-top: 2%; margin-bottom: 2%"
              *ngIf="showNumberOfForms"
            >
              <div class="col-lg-3"></div>

              <div class="col-lg-4 text-center">
                <form novalidate [formGroup]="formValid">
                  <mat-form-field appearance="outline">
                    <mat-label i18n="@@spmsUserReglastname"
                      >Number Of Forms</mat-label
                    >

                    <input
                      matInput
                      type="text"
                      formControlName="inputNumberOfForms"
                      [(ngModel)]="inputNumberOfForms"
                    />

                    <mat-error
                      *ngFor="
                        let validation of validation_messages.numberOfForms
                      "
                    >
                      <span
                        *ngIf="
                          formValid
                            .get('inputNumberOfForms')
                            .hasError(validation.type) &&
                          (formValid.get('inputNumberOfForms').dirty ||
                            formValid.get('inputNumberOfForms').touched)
                        "
                      >
                        {{ validation.message }}
                      </span>
                    </mat-error>
                  </mat-form-field>
                </form>
              </div>

              <div class="col-lg-2 text-center">
                <button
                  i18n="@@spmsloginbutton"
                  type="button"
                  (click)="enterNumberOfForms()"
                  class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
      [style.background-color]="backgroundColorButton"
       style="
                    font-size: 0.85rem;
                    padding-left: 1.2rem;
                    padding-right: 1.2rem;
                    padding-top: 0.4rem;
                    padding-bottom: 0.4rem;
                  "
                >
                  OK
                </button>
              </div>
            </div>

            <div>
              <div>
                <div class="row" *ngFor="let arrayIndex of numberOfFormsArray">
                  <div class="col-lg-3"></div>

                  <!--Iterating FormGroups-->
                  <div class="col-lg-6">
                    <form
                      novalidate
                      [formGroup]="formValidAllFieldsArray[arrayIndex]"
                    >
                      <div
                        class="row"
                        style="
                          margin-top: 2%;
                          margin-bottom: 2%;
                          font-weight: bold;
                        "
                      >
                        <div class="col-lg-12 text-center">
                          {{ formNames[arrayIndex] }}
                        </div>
                      </div>

                      <div
                        class="row"
                        *ngFor="
                          let screenCreatorDataTemp of screenCreatorData[
                            arrayIndex
                          ]
                        "
                      >
                        <div
                          class="col-lg-12"
                          *ngIf="
                            screenCreatorDataTemp.checkingDataType ==
                              'Yes|No' ||
                            screenCreatorDataTemp.checkingDataType == 'text' ||
                            screenCreatorDataTemp.checkingDataType == 'INT' ||
                            screenCreatorDataTemp.checkingDataType == 'DATE' ||
                            screenCreatorDataTemp.checkingDataType ==
                              'DATETIME' ||
                            screenCreatorDataTemp.checkingDataType ==
                              'Dropdown' ||
                            screenCreatorDataTemp.checkingDataType ==
                              'TextChanging'
                          "
                        >
                          <div class="row">
                            <div class="col-lg-12" style="margin-bottom: 2%">
                              <div
                                *ngIf="
                                  screenCreatorDataTemp.checkingDataType ==
                                  'Yes|No'
                                "
                              >
                                <mat-form-field appearance="outline">
                                  <mat-label i18n="@@spmsUserReglastname">{{
                                    screenCreatorDataTemp.displayNameInField
                                  }}</mat-label>

                                  <mat-select
                                    formControlName="{{
                                      screenCreatorDataTemp.keyName
                                    }}"
                                    [(ngModel)]="screenCreatorDataTemp.keyValue"
                                  >
                                    <mat-option
                                      *ngFor="
                                        let booleanDataTemp of booleanData
                                      "
                                      [(value)]="booleanDataTemp.value"
                                    >
                                      {{ booleanDataTemp.name }}
                                    </mat-option>
                                  </mat-select>

                                  <mat-error
                                    *ngFor="
                                      let validation of screenCreatorDataTemp.validationMessages
                                    "
                                  >
                                    <span
                                      *ngIf="
                                        formValidAllFieldsArray[arrayIndex]
                                          .get(screenCreatorDataTemp.keyName)
                                          .hasError(validation.type) &&
                                        (formValidAllFieldsArray[
                                          arrayIndex
                                        ].get(screenCreatorDataTemp.keyName)
                                          .dirty ||
                                          formValidAllFieldsArray[
                                            arrayIndex
                                          ].get(screenCreatorDataTemp.keyName)
                                            .touched)
                                      "
                                      style="margin-bottom: 1%"
                                    >
                                      {{ validation.message }}
                                    </span>
                                  </mat-error>
                                </mat-form-field>
                              </div>

                              <div
                                *ngIf="
                                  screenCreatorDataTemp.checkingDataType ==
                                  'text'
                                "
                              >
                                <mat-form-field appearance="outline">
                                  <mat-label i18n="@@spmsUserReglastname">{{
                                    screenCreatorDataTemp.displayNameInField
                                  }}</mat-label>

                                  <input
                                    matInput
                                    type="text"
                                    formControlName="{{
                                      screenCreatorDataTemp.keyName
                                    }}"
                                    [(ngModel)]="screenCreatorDataTemp.keyValue"
                                  />

                                  <mat-error
                                    *ngFor="
                                      let validation of screenCreatorDataTemp.validationMessages
                                    "
                                  >
                                    <span
                                      *ngIf="
                                        formValidAllFieldsArray[arrayIndex]
                                          .get(screenCreatorDataTemp.keyName)
                                          .hasError(validation.type) &&
                                        (formValidAllFieldsArray[
                                          arrayIndex
                                        ].get(screenCreatorDataTemp.keyName)
                                          .dirty ||
                                          formValidAllFieldsArray[
                                            arrayIndex
                                          ].get(screenCreatorDataTemp.keyName)
                                            .touched)
                                      "
                                      style="margin-bottom: 1%"
                                    >
                                      {{ validation.message }}
                                    </span>
                                  </mat-error>
                                </mat-form-field>
                              </div>

                              <div
                                *ngIf="
                                  screenCreatorDataTemp.checkingDataType ==
                                  'TextChanging'
                                "
                              >
                                <mat-form-field appearance="outline">
                                  <mat-label i18n="@@spmsUserReglastname">{{
                                    screenCreatorDataTemp.displayNameInField
                                  }}</mat-label>

                                  <input
                                    matInput
                                    type="text"
                                    formControlName="{{
                                      screenCreatorDataTemp.keyName
                                    }}"
                                    [(ngModel)]="screenCreatorDataTemp.keyValue"
                                    (ngModelChange)="
                                      changeOtherFieldValue(
                                        screenCreatorDataTemp,
                                        arrayIndex
                                      )
                                    "
                                  />

                                  <mat-error
                                    *ngFor="
                                      let validation of screenCreatorDataTemp.validationMessages
                                    "
                                  >
                                    <span
                                      *ngIf="
                                        formValidAllFieldsArray[arrayIndex]
                                          .get(screenCreatorDataTemp.keyName)
                                          .hasError(validation.type) &&
                                        (formValidAllFieldsArray[
                                          arrayIndex
                                        ].get(screenCreatorDataTemp.keyName)
                                          .dirty ||
                                          formValidAllFieldsArray[
                                            arrayIndex
                                          ].get(screenCreatorDataTemp.keyName)
                                            .touched)
                                      "
                                      style="margin-bottom: 1%"
                                    >
                                      {{ validation.message }}
                                    </span>
                                  </mat-error>
                                </mat-form-field>
                              </div>

                              <div
                                *ngIf="
                                  screenCreatorDataTemp.checkingDataType ==
                                  'INT'
                                "
                              >
                                <mat-form-field appearance="outline">
                                  <mat-label i18n="@@spmsUserReglastname">{{
                                    screenCreatorDataTemp.displayNameInField
                                  }}</mat-label>

                                  <input
                                    matInput
                                    type="text"
                                    formControlName="{{
                                      screenCreatorDataTemp.keyName
                                    }}"
                                    [(ngModel)]="screenCreatorDataTemp.keyValue"
                                  />

                                  <mat-error
                                    *ngFor="
                                      let validation of screenCreatorDataTemp.validationMessages
                                    "
                                  >
                                    <span
                                      *ngIf="
                                        formValidAllFieldsArray[arrayIndex]
                                          .get(screenCreatorDataTemp.keyName)
                                          .hasError(validation.type) &&
                                        (formValidAllFieldsArray[
                                          arrayIndex
                                        ].get(screenCreatorDataTemp.keyName)
                                          .dirty ||
                                          formValidAllFieldsArray[
                                            arrayIndex
                                          ].get(screenCreatorDataTemp.keyName)
                                            .touched)
                                      "
                                    >
                                      {{ validation.message }}
                                    </span>
                                  </mat-error>
                                </mat-form-field>
                              </div>

                              <div
                                *ngIf="
                                  screenCreatorDataTemp.checkingDataType ==
                                  'DATE'
                                "
                              >
                                <mat-form-field appearance="outline">
                                  <mat-label i18n="@@spmsUserReglastname">{{
                                    screenCreatorDataTemp.displayNameInField
                                  }}</mat-label>

                                  <input
                                    matInput
                                    formControlName="{{
                                      screenCreatorDataTemp.keyName
                                    }}"
                                    [(ngModel)]="screenCreatorDataTemp.keyValue"
                                    [matDatepicker]="i"
                                    [min]="screenCreatorDataTemp.startDateValue"
                                    [max]="screenCreatorDataTemp.endDateValue"
                                    readonly
                                    (dateChange)="
                                      changeStartEndDateValue(
                                        screenCreatorDataTemp
                                      )
                                    "
                                  />

                                  <mat-datepicker-toggle matSuffix [for]="i">
                                    <mat-icon matDatepickerToggleIcon
                                      >keyboard_arrow_down</mat-icon
                                    >
                                  </mat-datepicker-toggle>

                                  <mat-datepicker #i></mat-datepicker>

                                  <mat-error
                                    *ngFor="
                                      let validation of screenCreatorDataTemp.validationMessages
                                    "
                                  >
                                    <span
                                      *ngIf="
                                        formValidAllFieldsArray[arrayIndex]
                                          .get(screenCreatorDataTemp.keyName)
                                          .hasError('matDatepickerParse') &&
                                        (formValidAllFieldsArray[
                                          arrayIndex
                                        ].get(screenCreatorDataTemp.keyName)
                                          .dirty ||
                                          formValidAllFieldsArray[
                                            arrayIndex
                                          ].get(screenCreatorDataTemp.keyName)
                                            .touched)
                                      "
                                    >
                                      {{ validation.message }}
                                    </span>
                                  </mat-error>

                                  <mat-error
                                    *ngFor="
                                      let validation of screenCreatorDataTemp.validationMessages
                                    "
                                  >
                                    <span
                                      *ngIf="
                                        formValidAllFieldsArray[arrayIndex]
                                          .get(screenCreatorDataTemp.keyName)
                                          .hasError(validation.type) &&
                                        (formValidAllFieldsArray[
                                          arrayIndex
                                        ].get(screenCreatorDataTemp.keyName)
                                          .dirty ||
                                          formValidAllFieldsArray[
                                            arrayIndex
                                          ].get(screenCreatorDataTemp.keyName)
                                            .touched)
                                      "
                                    >
                                      {{ validation.message }}
                                    </span>
                                  </mat-error>
                                </mat-form-field>
                              </div>

                              <div
                                *ngIf="
                                  screenCreatorDataTemp.checkingDataType ==
                                  'DATETIME'
                                "
                              >
                                <mat-form-field appearance="outline">
                                  <mat-label i18n="TargetDateTime">{{
                                    screenCreatorDataTemp.displayNameInField
                                  }}</mat-label>

                                  <input
                                    matInput
                                    [(ngModel)]="screenCreatorDataTemp.keyValue"
                                    [owlDateTimeTrigger]="i"
                                    [owlDateTime]="i"
                                    formControlName="{{
                                      screenCreatorDataTemp.keyName
                                    }}"
                                    [min]="
                                      screenCreatorDataTemp.startDateTimeValue
                                    "
                                    [max]="
                                      screenCreatorDataTemp.endDateTimeValue
                                    "
                                    readonly
                                    (dateTimeChange)="
                                      changeStartEndDateTimeValue(
                                        screenCreatorDataTemp
                                      )
                                    "
                                  />

                                  <em
                                    [owlDateTimeTrigger]="i"
                                    class="fas fa-caret-down"
                                    style="
                                      display: flex;
                                      position: absolute;
                                      top: 1%;
                                      left: 93%;
                                    "
                                  ></em>

                                  <owl-date-time #i></owl-date-time>

                                  <mat-error
                                    *ngFor="
                                      let validation of screenCreatorDataTemp.validationMessages
                                    "
                                  >
                                    <span
                                      *ngIf="
                                        formValidAllFieldsArray[arrayIndex]
                                          .get(screenCreatorDataTemp.keyName)
                                          .hasError(validation.type) &&
                                        (formValidAllFieldsArray[
                                          arrayIndex
                                        ].get(screenCreatorDataTemp.keyName)
                                          .dirty ||
                                          formValidAllFieldsArray[
                                            arrayIndex
                                          ].get(screenCreatorDataTemp.keyName)
                                            .touched)
                                      "
                                    >
                                      {{ validation.message }}
                                    </span>
                                  </mat-error>
                                </mat-form-field>
                              </div>

                              <div
                                *ngIf="
                                  screenCreatorDataTemp.checkingDataType ==
                                  'Dropdown'
                                "
                              >
                                <mat-form-field appearance="outline">
                                  <mat-label i18n="@@Targetstdcode">{{
                                    screenCreatorDataTemp.displayNameInField
                                  }}</mat-label>

                                  <mat-select
                                    formControlName="{{
                                      screenCreatorDataTemp.keyName
                                    }}"
                                    [(ngModel)]="screenCreatorDataTemp.keyValue"
                                    (ngModelChange)="
                                      childDropDown(
                                        screenCreatorDataTemp,
                                        arrayIndex
                                      )
                                    "
                                  >
                                    <mat-option>None</mat-option>

                                    <span
                                      *ngFor="
                                        let temporaryObject of listObjectDropDown[
                                          arrayIndex
                                        ][screenCreatorDataTemp.dropDownIndex]
                                      "
                                    >
                                      <mat-option
                                        *ngFor="
                                          let tempObject of temporaryObject.keyJson
                                        "
                                        [value]="tempObject"
                                        [disabled]="
                                          temporaryObject.status == 'No'
                                        "
                                      >
                                        {{
                                          temporaryObject.dropDownValueDisplay
                                        }}
                                      </mat-option>
                                    </span>
                                  </mat-select>

                                  <mat-error
                                    *ngFor="
                                      let validation of screenCreatorDataTemp.validationMessages
                                    "
                                  >
                                    <span
                                      *ngIf="
                                        formValidAllFieldsArray[arrayIndex]
                                          .get(screenCreatorDataTemp.keyName)
                                          .hasError(validation.type) &&
                                        (formValidAllFieldsArray[
                                          arrayIndex
                                        ].get(screenCreatorDataTemp.keyName)
                                          .dirty ||
                                          formValidAllFieldsArray[
                                            arrayIndex
                                          ].get(screenCreatorDataTemp.keyName)
                                            .touched)
                                      "
                                      style="margin-bottom: 1%"
                                    >
                                      {{ validation.message }}
                                    </span>
                                  </mat-error>
                                </mat-form-field>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>

                  <div class="col-lg-3"></div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div class="row topRowmargins" style="margin-top: 1%">
              <div class="col-lg"></div>

              <div class="col-lg text-center">
                <button
                  i18n="@@spmsloginbutton"
                  type="button"
                  (click)="addField()"
                 class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
      [style.background-color]="backgroundColorButton"
      style="
                    font-size: 0.85rem;
                    padding-left: 1.2rem;
                    padding-right: 1.2rem;
                    padding-top: 0.4rem;
                    padding-bottom: 0.4rem;
                  "
                >
                  Create
                </button>
              </div>

              <div class="col-lg"></div>
            </div>

            <div class="row topRowmargins" style="margin-top: 1%">
              <div class="col-lg-12">
                <button
                  type="button"
                  class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
      [style.background-color]="backgroundColorButton"
      style="
                    font-size: 0.85rem;
                    padding-left: 1.2rem;
                    padding-right: 1.2rem;
                    padding-top: 0.4rem;
                    padding-bottom: 0.4rem;
                  "
                  (click)="fieldNamesBack(stepper)"
                >
                  Back
                </button>

                <button
                  type="button"
                 class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
               [style.background-color]="backgroundColorButton"  style="
                    font-size: 0.85rem;
                    float: right;
                    padding-left: 1.2rem;
                    padding-right: 1.2rem;
                    padding-top: 0.4rem;
                    padding-bottom: 0.4rem;
                  "
                  (click)="close()"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-step>
  </mat-horizontal-stepper>
</div>
